import React, { useState, useCallback, useEffect } from "react";
import TableFilter from "./TableFilter";
import DocumentAddEdit from "./DocumentAddEdit";
import { useNavigate } from "react-router-dom";
import { useClient } from '../../config/ClientProvider';

const DocumentList = ({ documentMeta, isModel = false }) => {
    const { selectedClient } = useClient();
    const navigate = useNavigate();
    const [drawCount, setDrawCount] = useState(0);
    const [showAddEditModel, setShowAddEditModel] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);


    // Show Parameter Add/Edit Model
    const toggleAddEditModel = () => setShowAddEditModel((prev) => !prev);

    // Response Parameter Create and Edit
    const handleAddEditRole = (row = null) => {
        if (isModel) {
            setCurrentRow(row);
            toggleAddEditModel();
        } else {
            let fetchDetails = {
                type: "fetch",
                currentRow: row,
                metaDataPath: documentMeta.filePath
            };
            let detail_Url = documentMeta.formUrl.replaceAll(":id", row.id);
            navigate(detail_Url, { state: row.id === undefined ? {} : fetchDetails });
        }
    };

    const getModuleTableView = useCallback(() => {
        return (
            <>
                <div className="row justify-content-end">
                    <div className="col-12 px-0">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="d-flex justify-content-end mb-3 me-0 table-info">
                                    <button type="button" className="btn btn-primary" onClick={handleAddEditRole}>Add New</button>
                                </div>
                                <TableFilter
                                    documentMeta={documentMeta}
                                    paginationStatus={true}
                                    drawCount={drawCount}
                                    showRecordUpdateModel={handleAddEditRole}
                                    refreshTableData={refreshTableData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }, [drawCount]);

    const refreshTableData = () => {
        setDrawCount((prev) => (prev + 1));
    };

    // useEffect to listen for selectedClient changes
    useEffect(() => {
        if (selectedClient) {
            // Any logic to re-fetch data or trigger updates when selectedClient changes
            refreshTableData();
        }
    }, [selectedClient]);

    return (
        <>
            {getModuleTableView()}
            {isModel && (
                <DocumentAddEdit
                    isOpen={showAddEditModel}
                    row={currentRow}
                    onClose={toggleAddEditModel}
                    onSuccessCallBack={() => setDrawCount((pre) => pre + 1)}
                    documentMeta={documentMeta}
                />
            )
            }
        </>
    );
};

export default DocumentList;
